<template>
  <div>
    <h3>Specificity of the Simulations module</h3>
                    <katex-element expression="\xi_\mathrm{max}" />, the maximum
                    value of <katex-element expression="\xi" /> possible,
                    changes with the warm-up duty cycle, which is calculated
                    based on the initial orbit of the mission. As such, the
                    effective value of
                    <katex-element expression="\xi_\mathrm{max}" /> will only be
                    calculated in the mission definition. The orbital duty cycle
                    will then be the lowest between
                    <katex-element expression="\xi" /> and
                    <katex-element expression="\xi_\mathrm{max}" />
                    <br />
                    <br />
                    Additionally, two cases need to be distinguished:
                    <ol>
                      <li>
                        Power system has <strong>not</strong> been defined:
                        <katex-element expression="\xi_\mathrm{max}" />
                        is then calculated from the orbital average power
                        available for propulsion and the power demands of the
                        propulsion system: thrust, warm-up and stand-by.
                      </li>
                      <li>
                        Power system has been defined: in this case the
                        propulsion system will be able to operate only if the
                        power made available by the solar arrays and the battery
                        is greater than the propulsion system's nominal power.
                      </li>
                    </ol>
  </div>
</template>

<script>
export default {
  name: 'tooltipDutyCycleNumerical'
}
</script>
